// W9c: members of a shared project (who writes with which actors and devices) and attribution over the documents'
// own history (History by member, revision marks by author, statistics by person). PROTOCOL.md §10.13 is the schema.
export {
  actorOf, hasMembers, memberForDevice, memberNeedsRecording, readMembers, recordMember, recordMemberIn, whoMadeObject, whoWrote, writerColor,
  writerName, MEMBERS_KEY, UNKNOWN_COLOR, UNKNOWN_DEVICE, type Member, type Members, type MemberSelf, type WrittenBy,
} from './members.ts';
export {
  byPerson, insertedBy, logOfDevices, newRuns, revisionChangesByAuthor, textAt, unknownPerson, wordsAddedBy, wordsByPerson,
  type ActorRun, type PersonFigure, type PersonWords,
} from './attribution.ts';
export {
  bylineJSON, CREDIT_ROLES, creditLines, creditRoleName, decodeByline, emptyByline, OWN_AUTHOR, readByline, rolesOf, setByline, withRoles,
  type Byline, type CreditRole,
} from './byline.ts';
